<template>
    <div>
        <div>
            确认进入学生{{$store.state.modal.data.student.student_name}}详情?
        </div>
        <div v-if="$store.state.modal.data.student.status=='absent'">
            <div>
                学生电话：{{$parentInfo.Dialog_GoToStudent.student_phone}}
            </div>
            <div v-for="parent in $parentInfo.Dialog_GoToStudent.parents" :key="parent.id">
                <div>
                    家长姓名：{{parent.name}}
                </div>
                <div>
                    家长电话：{{parent.phone}}
                </div>
            </div>
        </div>

       <div style="text-align: right">
           <el-button @click="handleGoTo()">确定</el-button>
       </div>
    </div>
</template>

<script>
    export default {
        name: "Dialog_GoToStudent",
        data() {
            return {
            }
        },
        created() {
            this.$parentInfo = this.$root.$children[0].$refs['dashboard'].$refs[this.$route.path];
            this.handleGetMsg();
        },
        methods: {
            handleGetMsg(){
                this.$parentInfo.Dialog_GoToStudent.student_phone='';
                this.$parentInfo.Dialog_GoToStudent.parents=[]
                if(this.$store.state.modal.data.student.status=='absent'){
                    this.$wApi.send(this.$parentInfo.path, 'get_student_phone', {
                        'student_id': this.$store.state.modal.data.student.student_id,
                    });
                }
            },
            handleGoTo() {
                this.$Win.closeModal()
                this.$store.dispatch('addView', {
                    'title': this.$store.state.modal.data.student.student_name,
                    'path': '/student/' + this.$store.state.modal.data.student.student_id,
                    'closable': true
                });
                this.router.push({path: '/student/' + this.$store.state.modal.data.student.student_id})
            },
        }
    }
</script>

<style scoped>

</style>